// This file is auto-generated by @hey-api/openapi-ts

import { type Options, deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHmember, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounsel, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicy, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHname, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHname, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHtheme, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHname, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHname, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcard, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbank, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbanner, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbest, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnew, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHreset, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcard, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbaby, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHreset, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbanner, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatest, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategory, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategory, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbanner, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommend, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffle, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchild, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalk, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhot, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipant, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalk, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviews, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhot, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucher, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsample, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnews, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagency, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbanner, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcard, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategory, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonline, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonline, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHprovider, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHall, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcard, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregion, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroom, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcode, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcount, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregion, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHlive, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurl, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaq, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocoding, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnews, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunity, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkb, deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpay, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHlogin, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHlogin, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincome, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtoken, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHlogin, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtype, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHlogin, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtoken, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheck, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccess, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnickname, putMETHODSLASHwelloSLASHv2SLASHallowsSLASHmessageDASHrejectSLASHmemberDASHwello, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcode, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHreset, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicy, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicy, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcount, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatest, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnew, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearch, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE, putMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHai, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunity, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnotice, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudget, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearning, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfo, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHbrand, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproduct, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHpopular, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACE, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategory, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocoding, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionary, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinner, deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3, putMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryption, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituation, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitor, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush, putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcount, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHext, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcomment, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucher, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHlive, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfo, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive, putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlanding, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphone, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheck, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregion, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpick, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpick, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhome, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcode, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHall, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbaby, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocation, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkb, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocoding, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseo, getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcount, postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrack } from '../sdk.gen';
import { type UseMutationOptions, type DefaultError, queryOptions, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { ResignMemberUsingDelete1Data, ResignMemberUsingDelete1Response, CreateApiCounselUsingPostData, CreateApiCounselUsingPostResponse, GetApiPolicyListUsingGetData, GetApiPolicyListUsingGetResponse, GetApiPolicyNameListUsingGetData, GetApiPolicyNameListUsingGetResponse, GetApiProductNameListUsingGetData, GetApiThemeListUsingGetData, GetApiThemeListUsingGetResponse, GetApiThemeNameListUsingGetData, GetApiThemeNameListUsingGetResponse, GetApiThemeUsingGetData, GetApiThemeKeywordNameListUsingGetData, GetApiThemeKeywordNameListUsingGetResponse, AvailCardListUsingGetData, BankListUsingGetData, BannerListUsingGetData, BestContentsListUsingGet1Data, BestContentsListUsingGet1Response, BestContentsFeedbackUsingGet1Data, GetNewBestContentsListUsingGet1Data, GetPopularBestContentsListUsingGet1Data, GetBestContentsUsingGetData, CommonCodeInitUsingPostData, CommonCodeInitUsingPostResponse, CardListUsingGetData, GetListChildcarePolicyBudgetUsingGetData, GetListChildcareRelatedPolicyUsingGet1Data, CommonCodeInitUsingPost1Data, CommonCodeInitUsingPost1Response, GetCommunityBannerListUsingGetData, GetLatestCommunityListUsingGet1Data, GetCommunityMainCategoryListUsingGetData, GetCommunitySubcategoryListByCodeUsingGetData, GetCommunityVoucherCategoryUsingGetData, GetRecommendCommunityVoucherCategoryUsingGetData, GetCommunityVoucherCategoryShuffleListUsingGetData, GetCommunityCategoryUsingGetData, GetCommunityVoucherCategoryPolicyListUsingGet1Data, GetCommunityFreeTalkListUsingGet1Data, GetCommunityFreeTalkListUsingGet1Response, FeedbackCommunityFreeTalkUsingGet1Data, GetCommunityFreeTalkHotListUsingGet1Data, GetCommunityFreeTalkHotListUsingGet1Response, GetPopularCommunityFreeTalkListUsingGet1Data, GetCommunityFreeTalkUsingGet1Data, GetCommunityParticipantListUsingGetData, GetCommunityParticipantListUsingGetResponse, GetCommunityPolicyTalkListUsingGet1Data, GetCommunityPolicyTalkListUsingGet1Response, FeedbackCommunityPolicyTalkUsingGet1Data, GetHomePolicyReviewListUsingGetData, GetCommunityPolicyTalkHotListUsingGet1Data, GetCommunityPolicyTalkHotListUsingGet1Response, GetCommunityPolicyTalkPolicyApplyListUsingGet1Data, GetPopularCommunityPolicyTalkListUsingGet1Data, GetCommunityPolicyTalkUsingGet1Data, GetCommunityVoucherListUsingGetData, GetCommunityVoucherListUsingGetResponse, FeedbackCommunityVoucherUsingGet1Data, GetSampleCommunityVoucherUsingGetData, GetCommunityVoucherUsingGetData, GetRelatedCommunityVoucherListUsingGetData, GetCommunityWelloNewsListUsingGet1Data, GetCommunityWelloNewsListUsingGet1Response, FeedbackCommunityWelloNewsUsingGet1Data, GetCommunityWelloNewsUsingGet1Data, GetEVoucherAgencyListUsingGetData, GetVoucherBannerListUsingGetData, GetEVoucherCardListUsingGetData, GetVoucherCategoryListUsingGetData, GetVoucherOnlineCategoryListUsingGetData, GetVoucherCategoryPolicyListUsingGetData, GetVoucherCategoryPolicyListUsingGetResponse, GetVoucherOnlineListUsingGetData, GetEVoucherProviderListUsingGet1Data, GetEVoucherProviderListUsingGet1Response, GetEVoucherProviderListAllUsingGet1Data, GetEVoucherProviderListAllUsingGet1Response, GetEVoucherProviderCardListUsingGetData, GetEVoucherProviderFeedbackUsingGet1Data, GetEVoucherProviderRegionListUsingGetData, GetEVoucherProviderUsingGet1Data, GetEmergencyRoomListUsingGet1Data, GetEmergencyRoomListUsingGet1Response, GetEmergencyRoomCodeListUsingGetData, GetEmergencyRoomListCountUsingGetData, GetEmergencyRoomListCountUsingGetResponse, GetEmergencyRoomRegionListUsingGetData, GetEmergencyRoomUsingGet1Data, GetEmergencyRoomLiveUsingGetData, ExpositionLinkUrlListUsingGetData, FaqListUsingGetData, GetNCloudGeocodingByCodeUsingGetData, HometownNewsListUsingGet1Data, HometownNewsListUsingGet1Response, HometownNewsFeedbackUsingGet1Data, GetPopularHometownNewsListUsingGet1Data, GetPopularHometownNewsListForCommunityUsingGet1Data, HometownNewsUsingGet1Data, GetRelatedHometownNewsListUsingGetData, JoinEventUsingPostData, JoinEventUsingPostResponse, ResignWelloWithKbPayUsingDeleteData, ResignWelloWithKbPayUsingDeleteResponse, LoginWelloWithKbPayUsingPostData, LoginWelloWithKbPayUsingPostResponse, SaveLoginResultUsingPostData, SaveLoginResultUsingPostResponse, TermHistoryUsingGetData, GetEVoucherProviderListUsingGet2Data, AdminRefreshTokenUsingGetData, WelloBeforeLoginUsingPostData, WelloBeforeLoginUsingPostResponse, GetKbMemberLoginTypeListUsingGetData, LoginWelloSnsMemberUsingPostData, LoginWelloSnsMemberUsingPostResponse, SnsRefreshTokenUsingGetData, TokenStatusCheckUsingPostData, TokenStatusCheckUsingPostResponse, CheckPlusSuccessUsingGetData, NoticeListUsingGetData, RejectMessageUsingPut1Data, RejectMessageUsingPut1Response, MetaCodeAllUsingGetData, CommonCodeInitUsingPost2Data, CommonCodeInitUsingPost2Response, AllowsInterestPolicyListUsingGetData, AllowsInterestPolicyListUsingGetResponse, MetaPolicyListUsingGet1Data, MetaPolicyListUsingGet1Response, MetaPolicyCountUsingGetData, MetaPolicyFeedbackUsingGet1Data, LatestMetaPolicyListUsingGetData, GetLatestPolicyListUsingGetData, GetPolicyListByPolicyNameUsingGetData, GetPolicyListByPolicyNameUsingGetResponse, PopularPolicyListUsingGetData, MetaPolicyTop10ListUsingGetData, MetaPolicyUsingGet1Data, UpdatePolicyAiInfoUsingPutData, UpdatePolicyAiInfoUsingPutResponse, GetRelatedMetaPolicyListUsingGet1Data, GetPolicyRelatedCommunityListUsingGetData, NoticeListUsingGet1Data, NoticeUsingGetData, GetPointBudgetUsingGet1Data, GetPointEarningUsingGetData, GetPointInfoUsingGetData, GetPointMarketBrandListUsingGetData, GetPointMarketProductListUsingGetData, GetPointMarketProductListUsingGetResponse, GetPopularPointMarketProductListUsingGetData, GetPointMarketProductUsingGetData, FeedbackPointMarketProductUsingPost1Data, FeedbackPointMarketProductUsingPost1Response, GetListPolicyCaseCategoryUsingGetData, GetPolicyCodeGeocodingListUsingGetData, GetPolicyDictionaryListUsingGetData, GetRandomTicketWinnerListUsingGetData, FileDeleteUsingDelete1Data, FileDeleteUsingDelete1Response, FileUploadUsingPost2Data, FileUploadUsingPost2Response, UpdateFileTempSaveYnUsingPut1Data, UpdateFileTempSaveYnUsingPut1Response, FileDecryptionDownloadUsingGet1Data, SituationListUsingGet1Data, GetSituationPolicyListUsingGet1Data, TermUsingGetData, GetWelcomeMonitorDisplayListUsingGetData, WelloAppPushListUsingGetData, WelloAppPushListUsingGetResponse, UpdateWelloAppPushReadUsingPut1Data, UpdateWelloAppPushReadUsingPut1Response, NewWelloAppPushCntUsingGetData, SendExtAppPushUsingPostData, SendExtAppPushUsingPostResponse, UpdateWelloAppPushReadUsingPostData, UpdateWelloAppPushReadUsingPostResponse, GetMetaPolicyCommentListUsingGet2Data, GetMetaPolicyCommentListUsingGet2Response, GetCommunityVoucherCommentListUsingGetData, GetCommunityVoucherCommentListUsingGetResponse, GetLiveWelloCommentListUsingGet1Data, GetMetaPolicyCommentListUsingGet1Data, SaveAllowsWelloDeviceInfoUsingPostData, SaveAllowsWelloDeviceInfoUsingPostResponse, MessageReceiveUsingGetData, UpdateMessageReceiveUsingPutData, UpdateMessageReceiveUsingPutResponse, DetailWelloLandingUsingGetData, SendCertificationCellphoneUsingPost1Data, SendCertificationCellphoneUsingPost1Response, CertificationCheckUsingPost1Data, CertificationCheckUsingPost1Response, SaveWelloNonmemberRegionUsingPostData, SaveWelloNonmemberRegionUsingPostResponse, WelloPickListUsingGet1Data, WelloPickPolicyListUsingGet1Data, GetWelloPickBannerListUsingGetData, GetHomeWelloPolicyApplyListUsingGetData, WelloPolicyCodeListUsingGetData, WelloPolicyCodeAllListUsingGetData, WelloPolicyCodeBabyListUsingGetData, GeolocationUsingGetData, KbWelloPolicyCodeAllListUsingGetData, ReverseGeocodingUsingGetData, MetaPolicyWishlistUsingGet1Data, MetaPolicyWishlistUsingGet1Response, MetaPolicyWishlistUsingGet2Data, SaveWelloTrackingUsingPost1Data, SaveWelloTrackingUsingPost1Response } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export const deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberMutation = (options?: Partial<Options<ResignMemberUsingDelete1Data>>) => {
    const mutationOptions: UseMutationOptions<ResignMemberUsingDelete1Response, DefaultError, Options<ResignMemberUsingDelete1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHmember({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounselQueryKey = (options?: Options<CreateApiCounselUsingPostData>) => createQueryKey('createApiCounselUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounselOptions = (options?: Options<CreateApiCounselUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounsel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounselQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounselMutation = (options?: Partial<Options<CreateApiCounselUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CreateApiCounselUsingPostResponse, DefaultError, Options<CreateApiCounselUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHcounsel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyQueryKey = (options: Options<GetApiPolicyListUsingGetData>) => createQueryKey('getApiPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyOptions = (options: Options<GetApiPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = queryKey[0];
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyInfiniteQueryKey = (options: Options<GetApiPolicyListUsingGetData>): QueryKey<Options<GetApiPolicyListUsingGetData>> => createQueryKey('getApiPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyInfiniteOptions = (options: Options<GetApiPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetApiPolicyListUsingGetResponse, DefaultError, InfiniteData<GetApiPolicyListUsingGetResponse>, QueryKey<Options<GetApiPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetApiPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameQueryKey = (options: Options<GetApiPolicyNameListUsingGetData>) => createQueryKey('getApiPolicyNameListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameOptions = (options: Options<GetApiPolicyNameListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHname({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameInfiniteQueryKey = (options: Options<GetApiPolicyNameListUsingGetData>): QueryKey<Options<GetApiPolicyNameListUsingGetData>> => createQueryKey('getApiPolicyNameListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameInfiniteOptions = (options: Options<GetApiPolicyNameListUsingGetData>) => {
    return infiniteQueryOptions<GetApiPolicyNameListUsingGetResponse, DefaultError, InfiniteData<GetApiPolicyNameListUsingGetResponse>, QueryKey<Options<GetApiPolicyNameListUsingGetData>>, number | Pick<QueryKey<Options<GetApiPolicyNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiPolicyNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHname({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHpolicySLASHnameInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHnameQueryKey = (options: Options<GetApiProductNameListUsingGetData>) => createQueryKey('getApiProductNameListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHnameOptions = (options: Options<GetApiProductNameListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHname({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHproductSLASHnameQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeQueryKey = (options: Options<GetApiThemeListUsingGetData>) => createQueryKey('getApiThemeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeOptions = (options: Options<GetApiThemeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHtheme({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeInfiniteQueryKey = (options: Options<GetApiThemeListUsingGetData>): QueryKey<Options<GetApiThemeListUsingGetData>> => createQueryKey('getApiThemeListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeInfiniteOptions = (options: Options<GetApiThemeListUsingGetData>) => {
    return infiniteQueryOptions<GetApiThemeListUsingGetResponse, DefaultError, InfiniteData<GetApiThemeListUsingGetResponse>, QueryKey<Options<GetApiThemeListUsingGetData>>, number | Pick<QueryKey<Options<GetApiThemeListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHtheme({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameQueryKey = (options: Options<GetApiThemeNameListUsingGetData>) => createQueryKey('getApiThemeNameListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameOptions = (options: Options<GetApiThemeNameListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHname({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameInfiniteQueryKey = (options: Options<GetApiThemeNameListUsingGetData>): QueryKey<Options<GetApiThemeNameListUsingGetData>> => createQueryKey('getApiThemeNameListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameInfiniteOptions = (options: Options<GetApiThemeNameListUsingGetData>) => {
    return infiniteQueryOptions<GetApiThemeNameListUsingGetResponse, DefaultError, InfiniteData<GetApiThemeNameListUsingGetResponse>, QueryKey<Options<GetApiThemeNameListUsingGetData>>, number | Pick<QueryKey<Options<GetApiThemeNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHname({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHnameInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACEQueryKey = (options: Options<GetApiThemeUsingGetData>) => createQueryKey('getApiThemeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACEOptions = (options: Options<GetApiThemeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHLBRACEapiUNDERSCOREthemeUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameQueryKey = (options: Options<GetApiThemeKeywordNameListUsingGetData>) => createQueryKey('getApiThemeKeywordNameListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameOptions = (options: Options<GetApiThemeKeywordNameListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHname({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameInfiniteQueryKey = (options: Options<GetApiThemeKeywordNameListUsingGetData>): QueryKey<Options<GetApiThemeKeywordNameListUsingGetData>> => createQueryKey('getApiThemeKeywordNameListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameInfiniteOptions = (options: Options<GetApiThemeKeywordNameListUsingGetData>) => {
    return infiniteQueryOptions<GetApiThemeKeywordNameListUsingGetResponse, DefaultError, InfiniteData<GetApiThemeKeywordNameListUsingGetResponse>, QueryKey<Options<GetApiThemeKeywordNameListUsingGetData>>, number | Pick<QueryKey<Options<GetApiThemeKeywordNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeKeywordNameListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHname({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHapiDASHthemeSLASHkeywordSLASHnameInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcardQueryKey = (options: Options<AvailCardListUsingGetData>) => createQueryKey('availCardListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcardOptions = (options: Options<AvailCardListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHavailDASHcardQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbankQueryKey = (options?: Options<BankListUsingGetData>) => createQueryKey('bankListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbankOptions = (options?: Options<BankListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbank({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbankQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbannerQueryKey = (options: Options<BannerListUsingGetData>) => createQueryKey('bannerListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbannerOptions = (options: Options<BannerListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHbannerQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestQueryKey = (options: Options<BestContentsListUsingGet1Data>) => createQueryKey('bestContentsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestOptions = (options: Options<BestContentsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestInfiniteQueryKey = (options: Options<BestContentsListUsingGet1Data>): QueryKey<Options<BestContentsListUsingGet1Data>> => createQueryKey('bestContentsListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestInfiniteOptions = (options: Options<BestContentsListUsingGet1Data>) => {
    return infiniteQueryOptions<BestContentsListUsingGet1Response, DefaultError, InfiniteData<BestContentsListUsingGet1Response>, QueryKey<Options<BestContentsListUsingGet1Data>>, number | Pick<QueryKey<Options<BestContentsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<BestContentsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbest({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEQueryKey = (options: Options<BestContentsFeedbackUsingGet1Data>) => createQueryKey('bestContentsFeedbackUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEOptions = (options: Options<BestContentsFeedbackUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHfeedbackSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnewQueryKey = (options?: Options<GetNewBestContentsListUsingGet1Data>) => createQueryKey('getNewBestContentsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnewOptions = (options?: Options<GetNewBestContentsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnew({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHnewQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopularQueryKey = (options?: Options<GetPopularBestContentsListUsingGet1Data>) => createQueryKey('getPopularBestContentsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopularOptions = (options?: Options<GetPopularBestContentsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetBestContentsUsingGetData>) => createQueryKey('getBestContentsUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetBestContentsUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHbestSLASHLBRACEbestUNDERSCOREcontentsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHresetQueryKey = (options: Options<CommonCodeInitUsingPostData>) => createQueryKey('commonCodeInitUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHresetOptions = (options: Options<CommonCodeInitUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHreset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHresetQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHresetMutation = (options?: Partial<Options<CommonCodeInitUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<CommonCodeInitUsingPostResponse, DefaultError, Options<CommonCodeInitUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHblocklistSLASHreset({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcardQueryKey = (options: Options<CardListUsingGetData>) => createQueryKey('cardListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcardOptions = (options: Options<CardListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcardQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabyQueryKey = (options: Options<GetListChildcarePolicyBudgetUsingGetData>) => createQueryKey('getListChildcarePolicyBudgetUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabyOptions = (options: Options<GetListChildcarePolicyBudgetUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbaby({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyQueryKey = (options: Options<GetListChildcareRelatedPolicyUsingGet1Data>) => createQueryKey('getListChildcareRelatedPolicyUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyOptions = (options: Options<GetListChildcareRelatedPolicyUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHbabySLASHrelatedDASHpolicyQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHresetQueryKey = (options: Options<CommonCodeInitUsingPost1Data>) => createQueryKey('commonCodeInitUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHresetOptions = (options: Options<CommonCodeInitUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHreset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHresetQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHresetMutation = (options?: Partial<Options<CommonCodeInitUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<CommonCodeInitUsingPost1Response, DefaultError, Options<CommonCodeInitUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommonSLASHmetaDASHcodeSLASHreset({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbannerQueryKey = (options?: Options<GetCommunityBannerListUsingGetData>) => createQueryKey('getCommunityBannerListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbannerOptions = (options?: Options<GetCommunityBannerListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHbannerQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatestQueryKey = (options?: Options<GetLatestCommunityListUsingGet1Data>) => createQueryKey('getLatestCommunityListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatestOptions = (options?: Options<GetLatestCommunityListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHlatestQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategoryQueryKey = (options?: Options<GetCommunityMainCategoryListUsingGetData>) => createQueryKey('getCommunityMainCategoryListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategoryOptions = (options?: Options<GetCommunityMainCategoryListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHmainDASHcategoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategoryQueryKey = (options: Options<GetCommunitySubcategoryListByCodeUsingGetData>) => createQueryKey('getCommunitySubcategoryListByCodeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategoryOptions = (options: Options<GetCommunitySubcategoryListByCodeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHsubcategoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbannerQueryKey = (options?: Options<GetCommunityVoucherCategoryUsingGetData>) => createQueryKey('getCommunityVoucherCategoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbannerOptions = (options?: Options<GetCommunityVoucherCategoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHbannerQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommendQueryKey = (options?: Options<GetRecommendCommunityVoucherCategoryUsingGetData>) => createQueryKey('getRecommendCommunityVoucherCategoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommendOptions = (options?: Options<GetRecommendCommunityVoucherCategoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommend({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHrecommendQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffleQueryKey = (options?: Options<GetCommunityVoucherCategoryShuffleListUsingGetData>) => createQueryKey('getCommunityVoucherCategoryShuffleListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffleOptions = (options?: Options<GetCommunityVoucherCategoryShuffleListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffle({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHvoucherDASHshuffleQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchildQueryKey = (options: Options<GetCommunityCategoryUsingGetData>) => createQueryKey('getCommunityCategoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchildOptions = (options: Options<GetCommunityCategoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchild({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHchildQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey = (options: Options<GetCommunityVoucherCategoryPolicyListUsingGet1Data>) => createQueryKey('getCommunityVoucherCategoryPolicyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyOptions = (options: Options<GetCommunityVoucherCategoryPolicyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHcategorySLASHLBRACEcommunityUNDERSCOREcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkQueryKey = (options: Options<GetCommunityFreeTalkListUsingGet1Data>) => createQueryKey('getCommunityFreeTalkListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkOptions = (options: Options<GetCommunityFreeTalkListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkInfiniteQueryKey = (options: Options<GetCommunityFreeTalkListUsingGet1Data>): QueryKey<Options<GetCommunityFreeTalkListUsingGet1Data>> => createQueryKey('getCommunityFreeTalkListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkInfiniteOptions = (options: Options<GetCommunityFreeTalkListUsingGet1Data>) => {
    return infiniteQueryOptions<GetCommunityFreeTalkListUsingGet1Response, DefaultError, InfiniteData<GetCommunityFreeTalkListUsingGet1Response>, QueryKey<Options<GetCommunityFreeTalkListUsingGet1Data>>, number | Pick<QueryKey<Options<GetCommunityFreeTalkListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityFreeTalkListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalk({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityFreeTalkUsingGet1Data>) => createQueryKey('feedbackCommunityFreeTalkUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityFreeTalkUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotQueryKey = (options: Options<GetCommunityFreeTalkHotListUsingGet1Data>) => createQueryKey('getCommunityFreeTalkHotListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotOptions = (options: Options<GetCommunityFreeTalkHotListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteQueryKey = (options: Options<GetCommunityFreeTalkHotListUsingGet1Data>): QueryKey<Options<GetCommunityFreeTalkHotListUsingGet1Data>> => createQueryKey('getCommunityFreeTalkHotListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteOptions = (options: Options<GetCommunityFreeTalkHotListUsingGet1Data>) => {
    return infiniteQueryOptions<GetCommunityFreeTalkHotListUsingGet1Response, DefaultError, InfiniteData<GetCommunityFreeTalkHotListUsingGet1Response>, QueryKey<Options<GetCommunityFreeTalkHotListUsingGet1Data>>, number | Pick<QueryKey<Options<GetCommunityFreeTalkHotListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityFreeTalkHotListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhot({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHhotInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopularQueryKey = (options?: Options<GetPopularCommunityFreeTalkListUsingGet1Data>) => createQueryKey('getPopularCommunityFreeTalkListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopularOptions = (options?: Options<GetPopularCommunityFreeTalkListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityFreeTalkUsingGet1Data>) => createQueryKey('getCommunityFreeTalkUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityFreeTalkUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHfreeDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantQueryKey = (options: Options<GetCommunityParticipantListUsingGetData>) => createQueryKey('getCommunityParticipantListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantOptions = (options: Options<GetCommunityParticipantListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipant({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantInfiniteQueryKey = (options: Options<GetCommunityParticipantListUsingGetData>): QueryKey<Options<GetCommunityParticipantListUsingGetData>> => createQueryKey('getCommunityParticipantListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantInfiniteOptions = (options: Options<GetCommunityParticipantListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityParticipantListUsingGetResponse, DefaultError, InfiniteData<GetCommunityParticipantListUsingGetResponse>, QueryKey<Options<GetCommunityParticipantListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityParticipantListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityParticipantListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipant({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHparticipantInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkQueryKey = (options: Options<GetCommunityPolicyTalkListUsingGet1Data>) => createQueryKey('getCommunityPolicyTalkListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkOptions = (options: Options<GetCommunityPolicyTalkListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkInfiniteQueryKey = (options: Options<GetCommunityPolicyTalkListUsingGet1Data>): QueryKey<Options<GetCommunityPolicyTalkListUsingGet1Data>> => createQueryKey('getCommunityPolicyTalkListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkInfiniteOptions = (options: Options<GetCommunityPolicyTalkListUsingGet1Data>) => {
    return infiniteQueryOptions<GetCommunityPolicyTalkListUsingGet1Response, DefaultError, InfiniteData<GetCommunityPolicyTalkListUsingGet1Response>, QueryKey<Options<GetCommunityPolicyTalkListUsingGet1Data>>, number | Pick<QueryKey<Options<GetCommunityPolicyTalkListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityPolicyTalkListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalk({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityPolicyTalkUsingGet1Data>) => createQueryKey('feedbackCommunityPolicyTalkUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityPolicyTalkUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviewsQueryKey = (options?: Options<GetHomePolicyReviewListUsingGetData>) => createQueryKey('getHomePolicyReviewListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviewsOptions = (options?: Options<GetHomePolicyReviewListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhomeSLASHpolicyDASHreviewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotQueryKey = (options: Options<GetCommunityPolicyTalkHotListUsingGet1Data>) => createQueryKey('getCommunityPolicyTalkHotListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotOptions = (options: Options<GetCommunityPolicyTalkHotListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteQueryKey = (options: Options<GetCommunityPolicyTalkHotListUsingGet1Data>): QueryKey<Options<GetCommunityPolicyTalkHotListUsingGet1Data>> => createQueryKey('getCommunityPolicyTalkHotListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteOptions = (options: Options<GetCommunityPolicyTalkHotListUsingGet1Data>) => {
    return infiniteQueryOptions<GetCommunityPolicyTalkHotListUsingGet1Response, DefaultError, InfiniteData<GetCommunityPolicyTalkHotListUsingGet1Response>, QueryKey<Options<GetCommunityPolicyTalkHotListUsingGet1Data>>, number | Pick<QueryKey<Options<GetCommunityPolicyTalkHotListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityPolicyTalkHotListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhot({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHhotInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyQueryKey = (options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGet1Data>) => createQueryKey('getCommunityPolicyTalkPolicyApplyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyOptions = (options?: Options<GetCommunityPolicyTalkPolicyApplyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpolicyDASHapplyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopularQueryKey = (options?: Options<GetPopularCommunityPolicyTalkListUsingGet1Data>) => createQueryKey('getPopularCommunityPolicyTalkListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopularOptions = (options?: Options<GetPopularCommunityPolicyTalkListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityPolicyTalkUsingGet1Data>) => createQueryKey('getCommunityPolicyTalkUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityPolicyTalkUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHpolicyDASHtalkSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherQueryKey = (options: Options<GetCommunityVoucherListUsingGetData>) => createQueryKey('getCommunityVoucherListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherOptions = (options: Options<GetCommunityVoucherListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucher({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherInfiniteQueryKey = (options: Options<GetCommunityVoucherListUsingGetData>): QueryKey<Options<GetCommunityVoucherListUsingGetData>> => createQueryKey('getCommunityVoucherListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherInfiniteOptions = (options: Options<GetCommunityVoucherListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityVoucherListUsingGetResponse, DefaultError, InfiniteData<GetCommunityVoucherListUsingGetResponse>, QueryKey<Options<GetCommunityVoucherListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityVoucherListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityVoucherListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucher({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityVoucherUsingGet1Data>) => createQueryKey('feedbackCommunityVoucherUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityVoucherUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsampleQueryKey = (options?: Options<GetSampleCommunityVoucherUsingGetData>) => createQueryKey('getSampleCommunityVoucherUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsampleOptions = (options?: Options<GetSampleCommunityVoucherUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsample({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHsampleQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityVoucherUsingGetData>) => createQueryKey('getCommunityVoucherUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityVoucherUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey = (options: Options<GetRelatedCommunityVoucherListUsingGetData>) => createQueryKey('getRelatedCommunityVoucherListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedOptions = (options: Options<GetRelatedCommunityVoucherListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHvoucherSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsQueryKey = (options: Options<GetCommunityWelloNewsListUsingGet1Data>) => createQueryKey('getCommunityWelloNewsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsOptions = (options: Options<GetCommunityWelloNewsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsInfiniteQueryKey = (options: Options<GetCommunityWelloNewsListUsingGet1Data>): QueryKey<Options<GetCommunityWelloNewsListUsingGet1Data>> => createQueryKey('getCommunityWelloNewsListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsInfiniteOptions = (options: Options<GetCommunityWelloNewsListUsingGet1Data>) => {
    return infiniteQueryOptions<GetCommunityWelloNewsListUsingGet1Response, DefaultError, InfiniteData<GetCommunityWelloNewsListUsingGet1Response>, QueryKey<Options<GetCommunityWelloNewsListUsingGet1Data>>, number | Pick<QueryKey<Options<GetCommunityWelloNewsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityWelloNewsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<FeedbackCommunityWelloNewsUsingGet1Data>) => createQueryKey('feedbackCommunityWelloNewsUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<FeedbackCommunityWelloNewsUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHfeedbackSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetCommunityWelloNewsUsingGet1Data>) => createQueryKey('getCommunityWelloNewsUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetCommunityWelloNewsUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcommunitySLASHwelloDASHnewsSLASHLBRACEcommunityUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagencyQueryKey = (options: Options<GetEVoucherAgencyListUsingGetData>) => createQueryKey('getEVoucherAgencyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagencyOptions = (options: Options<GetEVoucherAgencyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagency({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHagencyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbannerQueryKey = (options?: Options<GetVoucherBannerListUsingGetData>) => createQueryKey('getVoucherBannerListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbannerOptions = (options?: Options<GetVoucherBannerListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbanner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHbannerQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcardQueryKey = (options?: Options<GetEVoucherCardListUsingGetData>) => createQueryKey('getEVoucherCardListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcardOptions = (options?: Options<GetEVoucherCardListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcardQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategoryQueryKey = (options?: Options<GetVoucherCategoryListUsingGetData>) => createQueryKey('getVoucherCategoryListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategoryOptions = (options?: Options<GetVoucherCategoryListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonlineQueryKey = (options?: Options<GetVoucherOnlineCategoryListUsingGetData>) => createQueryKey('getVoucherOnlineCategoryListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonlineOptions = (options?: Options<GetVoucherOnlineCategoryListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHonlineQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey = (options: Options<GetVoucherCategoryPolicyListUsingGetData>) => createQueryKey('getVoucherCategoryPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyOptions = (options: Options<GetVoucherCategoryPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyInfiniteQueryKey = (options: Options<GetVoucherCategoryPolicyListUsingGetData>): QueryKey<Options<GetVoucherCategoryPolicyListUsingGetData>> => createQueryKey('getVoucherCategoryPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyInfiniteOptions = (options: Options<GetVoucherCategoryPolicyListUsingGetData>) => {
    return infiniteQueryOptions<GetVoucherCategoryPolicyListUsingGetResponse, DefaultError, InfiniteData<GetVoucherCategoryPolicyListUsingGetResponse>, QueryKey<Options<GetVoucherCategoryPolicyListUsingGetData>>, number | Pick<QueryKey<Options<GetVoucherCategoryPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetVoucherCategoryPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHcategorySLASHLBRACEcategoryUNDERSCOREidRBRACESLASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonlineQueryKey = (options: Options<GetVoucherOnlineListUsingGetData>) => createQueryKey('getVoucherOnlineListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonlineOptions = (options: Options<GetVoucherOnlineListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonline({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHonlineQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderQueryKey = (options: Options<GetEVoucherProviderListUsingGet1Data>) => createQueryKey('getEVoucherProviderListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderOptions = (options: Options<GetEVoucherProviderListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHprovider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderInfiniteQueryKey = (options: Options<GetEVoucherProviderListUsingGet1Data>): QueryKey<Options<GetEVoucherProviderListUsingGet1Data>> => createQueryKey('getEVoucherProviderListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderInfiniteOptions = (options: Options<GetEVoucherProviderListUsingGet1Data>) => {
    return infiniteQueryOptions<GetEVoucherProviderListUsingGet1Response, DefaultError, InfiniteData<GetEVoucherProviderListUsingGet1Response>, QueryKey<Options<GetEVoucherProviderListUsingGet1Data>>, number | Pick<QueryKey<Options<GetEVoucherProviderListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEVoucherProviderListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHprovider({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallQueryKey = (options: Options<GetEVoucherProviderListAllUsingGet1Data>) => createQueryKey('getEVoucherProviderListAllUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallOptions = (options: Options<GetEVoucherProviderListAllUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallInfiniteQueryKey = (options: Options<GetEVoucherProviderListAllUsingGet1Data>): QueryKey<Options<GetEVoucherProviderListAllUsingGet1Data>> => createQueryKey('getEVoucherProviderListAllUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallInfiniteOptions = (options: Options<GetEVoucherProviderListAllUsingGet1Data>) => {
    return infiniteQueryOptions<GetEVoucherProviderListAllUsingGet1Response, DefaultError, InfiniteData<GetEVoucherProviderListAllUsingGet1Response>, QueryKey<Options<GetEVoucherProviderListAllUsingGet1Data>>, number | Pick<QueryKey<Options<GetEVoucherProviderListAllUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEVoucherProviderListAllUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHall({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHallInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcardQueryKey = (options: Options<GetEVoucherProviderCardListUsingGetData>) => createQueryKey('getEVoucherProviderCardListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcardOptions = (options: Options<GetEVoucherProviderCardListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHcardQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEQueryKey = (options: Options<GetEVoucherProviderFeedbackUsingGet1Data>) => createQueryKey('getEVoucherProviderFeedbackUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEOptions = (options: Options<GetEVoucherProviderFeedbackUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHfeedbackSLASHLBRACEidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregionQueryKey = (options: Options<GetEVoucherProviderRegionListUsingGetData>) => createQueryKey('getEVoucherProviderRegionListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregionOptions = (options: Options<GetEVoucherProviderRegionListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHregionQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEQueryKey = (options: Options<GetEVoucherProviderUsingGet1Data>) => createQueryKey('getEVoucherProviderUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEOptions = (options: Options<GetEVoucherProviderUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHvoucherSLASHproviderSLASHLBRACEproviderUNDERSCOREuuidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomQueryKey = (options: Options<GetEmergencyRoomListUsingGet1Data>) => createQueryKey('getEmergencyRoomListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomOptions = (options: Options<GetEmergencyRoomListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroom({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomInfiniteQueryKey = (options: Options<GetEmergencyRoomListUsingGet1Data>): QueryKey<Options<GetEmergencyRoomListUsingGet1Data>> => createQueryKey('getEmergencyRoomListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomInfiniteOptions = (options: Options<GetEmergencyRoomListUsingGet1Data>) => {
    return infiniteQueryOptions<GetEmergencyRoomListUsingGet1Response, DefaultError, InfiniteData<GetEmergencyRoomListUsingGet1Response>, QueryKey<Options<GetEmergencyRoomListUsingGet1Data>>, number | Pick<QueryKey<Options<GetEmergencyRoomListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEmergencyRoomListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroom({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcodeQueryKey = (options?: Options<GetEmergencyRoomCodeListUsingGetData>) => createQueryKey('getEmergencyRoomCodeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcodeOptions = (options?: Options<GetEmergencyRoomCodeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcodeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountQueryKey = (options: Options<GetEmergencyRoomListCountUsingGetData>) => createQueryKey('getEmergencyRoomListCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountOptions = (options: Options<GetEmergencyRoomListCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountInfiniteQueryKey = (options: Options<GetEmergencyRoomListCountUsingGetData>): QueryKey<Options<GetEmergencyRoomListCountUsingGetData>> => createQueryKey('getEmergencyRoomListCountUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountInfiniteOptions = (options: Options<GetEmergencyRoomListCountUsingGetData>) => {
    return infiniteQueryOptions<GetEmergencyRoomListCountUsingGetResponse, DefaultError, InfiniteData<GetEmergencyRoomListCountUsingGetResponse>, QueryKey<Options<GetEmergencyRoomListCountUsingGetData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListCountUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEmergencyRoomListCountUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcount({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHcountInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregionQueryKey = (options: Options<GetEmergencyRoomRegionListUsingGetData>) => createQueryKey('getEmergencyRoomRegionListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregionOptions = (options: Options<GetEmergencyRoomRegionListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHregionQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEQueryKey = (options: Options<GetEmergencyRoomUsingGet1Data>) => createQueryKey('getEmergencyRoomUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEOptions = (options: Options<GetEmergencyRoomUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHliveQueryKey = (options: Options<GetEmergencyRoomLiveUsingGetData>) => createQueryKey('getEmergencyRoomLiveUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHliveOptions = (options: Options<GetEmergencyRoomLiveUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHemergencyDASHroomSLASHLBRACEemergencyRoomIdRBRACESLASHliveQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurlQueryKey = (options?: Options<ExpositionLinkUrlListUsingGetData>) => createQueryKey('expositionLinkUrlListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurlOptions = (options?: Options<ExpositionLinkUrlListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHexpositionDASHlinkDASHurlQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaqQueryKey = (options?: Options<FaqListUsingGetData>) => createQueryKey('faqListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaqOptions = (options?: Options<FaqListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaq({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHfaqQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocodingQueryKey = (options: Options<GetNCloudGeocodingByCodeUsingGetData>) => createQueryKey('getNCloudGeocodingByCodeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocodingOptions = (options: Options<GetNCloudGeocodingByCodeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocoding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHgeocodingQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsQueryKey = (options: Options<HometownNewsListUsingGet1Data>) => createQueryKey('hometownNewsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsOptions = (options: Options<HometownNewsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsInfiniteQueryKey = (options: Options<HometownNewsListUsingGet1Data>): QueryKey<Options<HometownNewsListUsingGet1Data>> => createQueryKey('hometownNewsListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsInfiniteOptions = (options: Options<HometownNewsListUsingGet1Data>) => {
    return infiniteQueryOptions<HometownNewsListUsingGet1Response, DefaultError, InfiniteData<HometownNewsListUsingGet1Response>, QueryKey<Options<HometownNewsListUsingGet1Data>>, number | Pick<QueryKey<Options<HometownNewsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<HometownNewsListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEQueryKey = (options: Options<HometownNewsFeedbackUsingGet1Data>) => createQueryKey('hometownNewsFeedbackUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEOptions = (options: Options<HometownNewsFeedbackUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHfeedbackSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularQueryKey = (options?: Options<GetPopularHometownNewsListUsingGet1Data>) => createQueryKey('getPopularHometownNewsListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularOptions = (options?: Options<GetPopularHometownNewsListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunityQueryKey = (options?: Options<GetPopularHometownNewsListForCommunityUsingGet1Data>) => createQueryKey('getPopularHometownNewsListForCommunityUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunityOptions = (options?: Options<GetPopularHometownNewsListForCommunityUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHpopularSLASHcommunityQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<HometownNewsUsingGet1Data>) => createQueryKey('hometownNewsUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<HometownNewsUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey = (options: Options<GetRelatedHometownNewsListUsingGetData>) => createQueryKey('getRelatedHometownNewsListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedOptions = (options: Options<GetRelatedHometownNewsListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHhometownDASHnewsSLASHLBRACEhometownUNDERSCOREnewsUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbQueryKey = (options?: Options<JoinEventUsingPostData>) => createQueryKey('joinEventUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbOptions = (options?: Options<JoinEventUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkb({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbMutation = (options?: Partial<Options<JoinEventUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<JoinEventUsingPostResponse, DefaultError, Options<JoinEventUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkb({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpayMutation = (options?: Partial<Options<ResignWelloWithKbPayUsingDeleteData>>) => {
    const mutationOptions: UseMutationOptions<ResignWelloWithKbPayUsingDeleteResponse, DefaultError, Options<ResignWelloWithKbPayUsingDeleteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpay({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHloginQueryKey = (options?: Options<LoginWelloWithKbPayUsingPostData>) => createQueryKey('loginWelloWithKbPayUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHloginOptions = (options?: Options<LoginWelloWithKbPayUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHloginMutation = (options?: Partial<Options<LoginWelloWithKbPayUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<LoginWelloWithKbPayUsingPostResponse, DefaultError, Options<LoginWelloWithKbPayUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHkbDASHpaySLASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHloginQueryKey = (options?: Options<SaveLoginResultUsingPostData>) => createQueryKey('saveLoginResultUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHloginOptions = (options?: Options<SaveLoginResultUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHloginMutation = (options?: Partial<Options<SaveLoginResultUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveLoginResultUsingPostResponse, DefaultError, Options<SaveLoginResultUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHappDASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEQueryKey = (options: Options<TermHistoryUsingGetData>) => createQueryKey('termHistoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEOptions = (options: Options<TermHistoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHlogDASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincomeQueryKey = (options?: Options<GetEVoucherProviderListUsingGet2Data>) => createQueryKey('getEVoucherProviderListUsingGet2', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincomeOptions = (options?: Options<GetEVoucherProviderListUsingGet2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincome({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmedianDASHincomeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtokenQueryKey = (options: Options<AdminRefreshTokenUsingGetData>) => createQueryKey('adminRefreshTokenUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtokenOptions = (options: Options<AdminRefreshTokenUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtoken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHadminSLASHrefreshUNDERSCOREtokenQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHloginQueryKey = (options?: Options<WelloBeforeLoginUsingPostData>) => createQueryKey('welloBeforeLoginUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHloginOptions = (options?: Options<WelloBeforeLoginUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHloginMutation = (options?: Partial<Options<WelloBeforeLoginUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<WelloBeforeLoginUsingPostResponse, DefaultError, Options<WelloBeforeLoginUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHbeforeSLASHsnsSLASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtypeQueryKey = (options: Options<GetKbMemberLoginTypeListUsingGetData>) => createQueryKey('getKbMemberLoginTypeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtypeOptions = (options: Options<GetKbMemberLoginTypeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtype({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHkbDASHmemberDASHloginDASHtypeQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHloginQueryKey = (options?: Options<LoginWelloSnsMemberUsingPostData>) => createQueryKey('loginWelloSnsMemberUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHloginOptions = (options?: Options<LoginWelloSnsMemberUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHlogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHloginQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHloginMutation = (options?: Partial<Options<LoginWelloSnsMemberUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<LoginWelloSnsMemberUsingPostResponse, DefaultError, Options<LoginWelloSnsMemberUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHlogin({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtokenQueryKey = (options: Options<SnsRefreshTokenUsingGetData>) => createQueryKey('snsRefreshTokenUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtokenOptions = (options: Options<SnsRefreshTokenUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtoken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHsnsSLASHrefreshUNDERSCOREtokenQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheckQueryKey = (options?: Options<TokenStatusCheckUsingPostData>) => createQueryKey('tokenStatusCheckUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheckOptions = (options?: Options<TokenStatusCheckUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheckMutation = (options?: Partial<Options<TokenStatusCheckUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<TokenStatusCheckUsingPostResponse, DefaultError, Options<TokenStatusCheckUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHoauthSLASHtokenDASHstatusDASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccessQueryKey = (options: Options<CheckPlusSuccessUsingGetData>) => createQueryKey('checkPlusSuccessUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccessOptions = (options: Options<CheckPlusSuccessUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHniceDASHsafeDASHkeySLASHcheckDASHplusUNDERSCOREsuccessQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnicknameQueryKey = (options?: Options<NoticeListUsingGetData>) => createQueryKey('noticeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnicknameOptions = (options?: Options<NoticeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnickname({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmemberDASHwelloSLASHnicknameQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHmessageDASHrejectSLASHmemberDASHwelloMutation = (options?: Partial<Options<RejectMessageUsingPut1Data>>) => {
    const mutationOptions: UseMutationOptions<RejectMessageUsingPut1Response, DefaultError, Options<RejectMessageUsingPut1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHallowsSLASHmessageDASHrejectSLASHmemberDASHwello({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeQueryKey = (options: Options<MetaCodeAllUsingGetData>) => createQueryKey('metaCodeAllUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeOptions = (options: Options<MetaCodeAllUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHresetQueryKey = (options: Options<CommonCodeInitUsingPost2Data>) => createQueryKey('commonCodeInitUsingPost2', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHresetOptions = (options: Options<CommonCodeInitUsingPost2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHreset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHresetQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHresetMutation = (options?: Partial<Options<CommonCodeInitUsingPost2Data>>) => {
    const mutationOptions: UseMutationOptions<CommonCodeInitUsingPost2Response, DefaultError, Options<CommonCodeInitUsingPost2Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHmetaDASHcodeSLASHreset({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyQueryKey = (options: Options<AllowsInterestPolicyListUsingGetData>) => createQueryKey('allowsInterestPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyOptions = (options: Options<AllowsInterestPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyInfiniteQueryKey = (options: Options<AllowsInterestPolicyListUsingGetData>): QueryKey<Options<AllowsInterestPolicyListUsingGetData>> => createQueryKey('allowsInterestPolicyListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyInfiniteOptions = (options: Options<AllowsInterestPolicyListUsingGetData>) => {
    return infiniteQueryOptions<AllowsInterestPolicyListUsingGetResponse, DefaultError, InfiniteData<AllowsInterestPolicyListUsingGetResponse>, QueryKey<Options<AllowsInterestPolicyListUsingGetData>>, number | Pick<QueryKey<Options<AllowsInterestPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AllowsInterestPolicyListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHinterestDASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyQueryKey = (options: Options<MetaPolicyListUsingGet1Data>) => createQueryKey('metaPolicyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyOptions = (options: Options<MetaPolicyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyInfiniteQueryKey = (options: Options<MetaPolicyListUsingGet1Data>): QueryKey<Options<MetaPolicyListUsingGet1Data>> => createQueryKey('metaPolicyListUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyInfiniteOptions = (options: Options<MetaPolicyListUsingGet1Data>) => {
    return infiniteQueryOptions<MetaPolicyListUsingGet1Response, DefaultError, InfiniteData<MetaPolicyListUsingGet1Response>, QueryKey<Options<MetaPolicyListUsingGet1Data>>, number | Pick<QueryKey<Options<MetaPolicyListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MetaPolicyListUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicy({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcountQueryKey = (options?: Options<MetaPolicyCountUsingGetData>) => createQueryKey('metaPolicyCountUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcountOptions = (options?: Options<MetaPolicyCountUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcountQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey = (options: Options<MetaPolicyFeedbackUsingGet1Data>) => createQueryKey('metaPolicyFeedbackUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEOptions = (options: Options<MetaPolicyFeedbackUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHfeedbackSLASHLBRACEpolicyUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestQueryKey = (options?: Options<LatestMetaPolicyListUsingGetData>) => createQueryKey('latestMetaPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestOptions = (options?: Options<LatestMetaPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnewQueryKey = (options?: Options<GetLatestPolicyListUsingGetData>) => createQueryKey('getLatestPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnewOptions = (options?: Options<GetLatestPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnew({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHlatestSLASHnewQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchQueryKey = (options: Options<GetPolicyListByPolicyNameUsingGetData>) => createQueryKey('getPolicyListByPolicyNameUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchOptions = (options: Options<GetPolicyListByPolicyNameUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchInfiniteQueryKey = (options: Options<GetPolicyListByPolicyNameUsingGetData>): QueryKey<Options<GetPolicyListByPolicyNameUsingGetData>> => createQueryKey('getPolicyListByPolicyNameUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchInfiniteOptions = (options: Options<GetPolicyListByPolicyNameUsingGetData>) => {
    return infiniteQueryOptions<GetPolicyListByPolicyNameUsingGetResponse, DefaultError, InfiniteData<GetPolicyListByPolicyNameUsingGetResponse>, QueryKey<Options<GetPolicyListByPolicyNameUsingGetData>>, number | Pick<QueryKey<Options<GetPolicyListByPolicyNameUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPolicyListByPolicyNameUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHnameDASHsearchInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopularQueryKey = (options?: Options<PopularPolicyListUsingGetData>) => createQueryKey('popularPolicyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopularOptions = (options?: Options<PopularPolicyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10QueryKey = (options?: Options<MetaPolicyTop10ListUsingGetData>) => createQueryKey('metaPolicyTop10ListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10Options = (options?: Options<MetaPolicyTop10ListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHtop10QueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<MetaPolicyUsingGet1Data>) => createQueryKey('metaPolicyUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<MetaPolicyUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHaiMutation = (options?: Partial<Options<UpdatePolicyAiInfoUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdatePolicyAiInfoUsingPutResponse, DefaultError, Options<UpdatePolicyAiInfoUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHai({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey = (options: Options<GetRelatedMetaPolicyListUsingGet1Data>) => createQueryKey('getRelatedMetaPolicyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedOptions = (options: Options<GetRelatedMetaPolicyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelated({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEmetaUNDERSCOREpolicyUNDERSCOREidUNDERSCOREidxRBRACESLASHrelatedQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunityQueryKey = (options: Options<GetPolicyRelatedCommunityListUsingGetData>) => createQueryKey('getPolicyRelatedCommunityListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunityOptions = (options: Options<GetPolicyRelatedCommunityListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicySLASHLBRACEpolicyUNDERSCOREidRBRACESLASHcommunityQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeQueryKey = (options?: Options<NoticeListUsingGet1Data>) => createQueryKey('noticeListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeOptions = (options?: Options<NoticeListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnotice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACEQueryKey = (options: Options<NoticeUsingGetData>) => createQueryKey('noticeUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACEOptions = (options: Options<NoticeUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcsSLASHnoticeSLASHLBRACEnoticeUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudgetQueryKey = (options?: Options<GetPointBudgetUsingGet1Data>) => createQueryKey('getPointBudgetUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudgetOptions = (options?: Options<GetPointBudgetUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudget({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHbudgetQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearningQueryKey = (options?: Options<GetPointEarningUsingGetData>) => createQueryKey('getPointEarningUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearningOptions = (options?: Options<GetPointEarningUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearning({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHearningQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfoQueryKey = (options: Options<GetPointInfoUsingGetData>) => createQueryKey('getPointInfoUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfoOptions = (options: Options<GetPointInfoUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointSLASHinfoQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHbrandQueryKey = (options?: Options<GetPointMarketBrandListUsingGetData>) => createQueryKey('getPointMarketBrandListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHbrandOptions = (options?: Options<GetPointMarketBrandListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHbrand({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHbrandQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductQueryKey = (options?: Options<GetPointMarketProductListUsingGetData>) => createQueryKey('getPointMarketProductListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductOptions = (options?: Options<GetPointMarketProductListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproduct({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductInfiniteQueryKey = (options?: Options<GetPointMarketProductListUsingGetData>): QueryKey<Options<GetPointMarketProductListUsingGetData>> => createQueryKey('getPointMarketProductListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductInfiniteOptions = (options?: Options<GetPointMarketProductListUsingGetData>) => {
    return infiniteQueryOptions<GetPointMarketProductListUsingGetResponse, DefaultError, InfiniteData<GetPointMarketProductListUsingGetResponse>, QueryKey<Options<GetPointMarketProductListUsingGetData>>, number | Pick<QueryKey<Options<GetPointMarketProductListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPointMarketProductListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproduct({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHpopularQueryKey = (options?: Options<GetPopularPointMarketProductListUsingGetData>) => createQueryKey('getPopularPointMarketProductListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHpopularOptions = (options?: Options<GetPopularPointMarketProductListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHpopular({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHpopularQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACEQueryKey = (options: Options<GetPointMarketProductUsingGetData>) => createQueryKey('getPointMarketProductUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACEOptions = (options: Options<GetPointMarketProductUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackQueryKey = (options: Options<FeedbackPointMarketProductUsingPost1Data>) => createQueryKey('feedbackPointMarketProductUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackOptions = (options: Options<FeedbackPointMarketProductUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedbackMutation = (options?: Partial<Options<FeedbackPointMarketProductUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<FeedbackPointMarketProductUsingPost1Response, DefaultError, Options<FeedbackPointMarketProductUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHpointDASHmarketSLASHproductSLASHLBRACEproductUNDERSCOREidUNDERSCOREidxRBRACESLASHfeedback({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategoryQueryKey = (options?: Options<GetListPolicyCaseCategoryUsingGetData>) => createQueryKey('getListPolicyCaseCategoryUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategoryOptions = (options?: Options<GetListPolicyCaseCategoryUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcaseSLASHcategoryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocodingQueryKey = (options?: Options<GetPolicyCodeGeocodingListUsingGetData>) => createQueryKey('getPolicyCodeGeocodingListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocodingOptions = (options?: Options<GetPolicyCodeGeocodingListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocoding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHcodeDASHgeocodingQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionaryQueryKey = (options?: Options<GetPolicyDictionaryListUsingGetData>) => createQueryKey('getPolicyDictionaryListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionaryOptions = (options?: Options<GetPolicyDictionaryListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionary({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHdictionaryQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinnerQueryKey = (options?: Options<GetRandomTicketWinnerListUsingGetData>) => createQueryKey('getRandomTicketWinnerListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinnerOptions = (options?: Options<GetRandomTicketWinnerListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHrandomDASHticketSLASHluckyDASHballSLASHwinnerQueryKey(options)
    });
};

export const deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3Mutation = (options?: Partial<Options<FileDeleteUsingDelete1Data>>) => {
    const mutationOptions: UseMutationOptions<FileDeleteUsingDelete1Response, DefaultError, Options<FileDeleteUsingDelete1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3QueryKey = (options?: Options<FileUploadUsingPost2Data>) => createQueryKey('fileUploadUsingPost2', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3Options = (options?: Options<FileUploadUsingPost2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3QueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3Mutation = (options?: Partial<Options<FileUploadUsingPost2Data>>) => {
    const mutationOptions: UseMutationOptions<FileUploadUsingPost2Response, DefaultError, Options<FileUploadUsingPost2Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3Mutation = (options?: Partial<Options<UpdateFileTempSaveYnUsingPut1Data>>) => {
    const mutationOptions: UseMutationOptions<UpdateFileTempSaveYnUsingPut1Response, DefaultError, Options<UpdateFileTempSaveYnUsingPut1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryptionQueryKey = (options: Options<FileDecryptionDownloadUsingGet1Data>) => createQueryKey('fileDecryptionDownloadUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryptionOptions = (options: Options<FileDecryptionDownloadUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryption({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHs3SLASHnonmemberDASHdecryptionQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationQueryKey = (options?: Options<SituationListUsingGet1Data>) => createQueryKey('situationListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationOptions = (options?: Options<SituationListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEQueryKey = (options: Options<GetSituationPolicyListUsingGet1Data>) => createQueryKey('getSituationPolicyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEOptions = (options: Options<GetSituationPolicyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHsituationSLASHLBRACEsituationUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEQueryKey = (options: Options<TermUsingGetData>) => createQueryKey('termUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEOptions = (options: Options<TermUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHtermSLASHLBRACEtermUNDERSCOREcategoryRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitorQueryKey = (options: Options<GetWelcomeMonitorDisplayListUsingGetData>) => createQueryKey('getWelcomeMonitorDisplayListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitorOptions = (options: Options<GetWelcomeMonitorDisplayListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitor({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelcomeDASHmonitorQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushQueryKey = (options: Options<WelloAppPushListUsingGetData>) => createQueryKey('welloAppPushListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushOptions = (options: Options<WelloAppPushListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushInfiniteQueryKey = (options: Options<WelloAppPushListUsingGetData>): QueryKey<Options<WelloAppPushListUsingGetData>> => createQueryKey('welloAppPushListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushInfiniteOptions = (options: Options<WelloAppPushListUsingGetData>) => {
    return infiniteQueryOptions<WelloAppPushListUsingGetResponse, DefaultError, InfiniteData<WelloAppPushListUsingGetResponse>, QueryKey<Options<WelloAppPushListUsingGetData>>, number | Pick<QueryKey<Options<WelloAppPushListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<WelloAppPushListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushInfiniteQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushMutation = (options?: Partial<Options<UpdateWelloAppPushReadUsingPut1Data>>) => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadUsingPut1Response, DefaultError, Options<UpdateWelloAppPushReadUsingPut1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpush({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcountQueryKey = (options: Options<NewWelloAppPushCntUsingGetData>) => createQueryKey('newWelloAppPushCntUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcountOptions = (options: Options<NewWelloAppPushCntUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHcountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHextQueryKey = (options?: Options<SendExtAppPushUsingPostData>) => createQueryKey('sendExtAppPushUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHextOptions = (options?: Options<SendExtAppPushUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHext({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHextQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHextMutation = (options?: Partial<Options<SendExtAppPushUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SendExtAppPushUsingPostResponse, DefaultError, Options<SendExtAppPushUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHext({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACEQueryKey = (options: Options<UpdateWelloAppPushReadUsingPostData>) => createQueryKey('updateWelloAppPushReadUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACEOptions = (options: Options<UpdateWelloAppPushReadUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACEMutation = (options?: Partial<Options<UpdateWelloAppPushReadUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadUsingPostResponse, DefaultError, Options<UpdateWelloAppPushReadUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHappDASHpushSLASHLBRACEwelloUNDERSCOREappUNDERSCOREpushUNDERSCOREreceiverUNDERSCOREidRBRACE({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentQueryKey = (options: Options<GetMetaPolicyCommentListUsingGet2Data>) => createQueryKey('getMetaPolicyCommentListUsingGet2', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentOptions = (options: Options<GetMetaPolicyCommentListUsingGet2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcomment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentInfiniteQueryKey = (options: Options<GetMetaPolicyCommentListUsingGet2Data>): QueryKey<Options<GetMetaPolicyCommentListUsingGet2Data>> => createQueryKey('getMetaPolicyCommentListUsingGet2', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentInfiniteOptions = (options: Options<GetMetaPolicyCommentListUsingGet2Data>) => {
    return infiniteQueryOptions<GetMetaPolicyCommentListUsingGet2Response, DefaultError, InfiniteData<GetMetaPolicyCommentListUsingGet2Response>, QueryKey<Options<GetMetaPolicyCommentListUsingGet2Data>>, number | Pick<QueryKey<Options<GetMetaPolicyCommentListUsingGet2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetMetaPolicyCommentListUsingGet2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcomment({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherQueryKey = (options: Options<GetCommunityVoucherCommentListUsingGetData>) => createQueryKey('getCommunityVoucherCommentListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherOptions = (options: Options<GetCommunityVoucherCommentListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucher({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherInfiniteQueryKey = (options: Options<GetCommunityVoucherCommentListUsingGetData>): QueryKey<Options<GetCommunityVoucherCommentListUsingGetData>> => createQueryKey('getCommunityVoucherCommentListUsingGet', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherInfiniteOptions = (options: Options<GetCommunityVoucherCommentListUsingGetData>) => {
    return infiniteQueryOptions<GetCommunityVoucherCommentListUsingGetResponse, DefaultError, InfiniteData<GetCommunityVoucherCommentListUsingGetResponse>, QueryKey<Options<GetCommunityVoucherCommentListUsingGetData>>, number | Pick<QueryKey<Options<GetCommunityVoucherCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityVoucherCommentListUsingGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucher({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHcommunityDASHvoucherInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHliveQueryKey = (options?: Options<GetLiveWelloCommentListUsingGet1Data>) => createQueryKey('getLiveWelloCommentListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHliveOptions = (options?: Options<GetLiveWelloCommentListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHliveQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEQueryKey = (options: Options<GetMetaPolicyCommentListUsingGet1Data>) => createQueryKey('getMetaPolicyCommentListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEOptions = (options: Options<GetMetaPolicyCommentListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHcommentSLASHLBRACEwelloCommentIdRBRACEQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoQueryKey = (options?: Options<SaveAllowsWelloDeviceInfoUsingPostData>) => createQueryKey('saveAllowsWelloDeviceInfoUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoOptions = (options?: Options<SaveAllowsWelloDeviceInfoUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoMutation = (options?: Partial<Options<SaveAllowsWelloDeviceInfoUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveAllowsWelloDeviceInfoUsingPostResponse, DefaultError, Options<SaveAllowsWelloDeviceInfoUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceiveQueryKey = (options: Options<MessageReceiveUsingGetData>) => createQueryKey('messageReceiveUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceiveOptions = (options: Options<MessageReceiveUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceiveQueryKey(options)
    });
};

export const putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceiveMutation = (options?: Partial<Options<UpdateMessageReceiveUsingPutData>>) => {
    const mutationOptions: UseMutationOptions<UpdateMessageReceiveUsingPutResponse, DefaultError, Options<UpdateMessageReceiveUsingPutData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await putMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHdeviceDASHinfoSLASHmessageDASHreceive({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlandingQueryKey = (options?: Options<DetailWelloLandingUsingGetData>) => createQueryKey('detailWelloLandingUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlandingOptions = (options?: Options<DetailWelloLandingUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlanding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHlandingQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphoneQueryKey = (options?: Options<SendCertificationCellphoneUsingPost1Data>) => createQueryKey('sendCertificationCellphoneUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphoneOptions = (options?: Options<SendCertificationCellphoneUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphone({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphoneQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphoneMutation = (options?: Partial<Options<SendCertificationCellphoneUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<SendCertificationCellphoneUsingPost1Response, DefaultError, Options<SendCertificationCellphoneUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcellphone({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheckQueryKey = (options?: Options<CertificationCheckUsingPost1Data>) => createQueryKey('certificationCheckUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheckOptions = (options?: Options<CertificationCheckUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheckQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheckMutation = (options?: Partial<Options<CertificationCheckUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<CertificationCheckUsingPost1Response, DefaultError, Options<CertificationCheckUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHcertificationSLASHcheck({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregionQueryKey = (options?: Options<SaveWelloNonmemberRegionUsingPostData>) => createQueryKey('saveWelloNonmemberRegionUsingPost', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregionOptions = (options?: Options<SaveWelloNonmemberRegionUsingPostData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregionQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregionMutation = (options?: Partial<Options<SaveWelloNonmemberRegionUsingPostData>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloNonmemberRegionUsingPostResponse, DefaultError, Options<SaveWelloNonmemberRegionUsingPostData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHnonmemberDASHregion({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickQueryKey = (options?: Options<WelloPickListUsingGet1Data>) => createQueryKey('welloPickListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickOptions = (options?: Options<WelloPickListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpick({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEQueryKey = (options: Options<WelloPickPolicyListUsingGet1Data>) => createQueryKey('welloPickPolicyListUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEOptions = (options: Options<WelloPickPolicyListUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACE({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHcontentsSLASHpickSLASHLBRACEwelloUNDERSCOREpickUNDERSCOREidRBRACEQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpickQueryKey = (options?: Options<GetWelloPickBannerListUsingGetData>) => createQueryKey('getWelloPickBannerListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpickOptions = (options?: Options<GetWelloPickBannerListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpick({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpickQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhomeQueryKey = (options?: Options<GetHomeWelloPolicyApplyListUsingGetData>) => createQueryKey('getHomeWelloPolicyApplyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhomeOptions = (options?: Options<GetHomeWelloPolicyApplyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhome({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHpolicyDASHapplySLASHhomeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeQueryKey = (options: Options<WelloPolicyCodeListUsingGetData>) => createQueryKey('welloPolicyCodeListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeOptions = (options: Options<WelloPolicyCodeListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHallQueryKey = (options?: Options<WelloPolicyCodeAllListUsingGetData>) => createQueryKey('welloPolicyCodeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHallOptions = (options?: Options<WelloPolicyCodeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHallQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbabyQueryKey = (options?: Options<WelloPolicyCodeBabyListUsingGetData>) => createQueryKey('welloPolicyCodeBabyListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbabyOptions = (options?: Options<WelloPolicyCodeBabyListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbaby({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHbabyQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocationQueryKey = (options: Options<GeolocationUsingGetData>) => createQueryKey('geolocationUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocationOptions = (options: Options<GeolocationUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHgeolocationQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkbQueryKey = (options?: Options<KbWelloPolicyCodeAllListUsingGetData>) => createQueryKey('kbWelloPolicyCodeAllListUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkbOptions = (options?: Options<KbWelloPolicyCodeAllListUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkb({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHkbQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocodingQueryKey = (options: Options<ReverseGeocodingUsingGetData>) => createQueryKey('reverseGeocodingUsingGet', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocodingOptions = (options: Options<ReverseGeocodingUsingGetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocoding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHpolicyDASHcodeSLASHreverseDASHgeocodingQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoQueryKey = (options: Options<MetaPolicyWishlistUsingGet1Data>) => createQueryKey('metaPolicyWishlistUsingGet1', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoOptions = (options: Options<MetaPolicyWishlistUsingGet1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoInfiniteQueryKey = (options: Options<MetaPolicyWishlistUsingGet1Data>): QueryKey<Options<MetaPolicyWishlistUsingGet1Data>> => createQueryKey('metaPolicyWishlistUsingGet1', options, true);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoInfiniteOptions = (options: Options<MetaPolicyWishlistUsingGet1Data>) => {
    return infiniteQueryOptions<MetaPolicyWishlistUsingGet1Response, DefaultError, InfiniteData<MetaPolicyWishlistUsingGet1Response>, QueryKey<Options<MetaPolicyWishlistUsingGet1Data>>, number | Pick<QueryKey<Options<MetaPolicyWishlistUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MetaPolicyWishlistUsingGet1Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseo({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoInfiniteQueryKey(options)
    });
};

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcountQueryKey = (options: Options<MetaPolicyWishlistUsingGet2Data>) => createQueryKey('metaPolicyWishlistUsingGet2', options);

export const getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcountOptions = (options: Options<MetaPolicyWishlistUsingGet2Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMETHODSLASHwelloSLASHv2SLASHallowsSLASHseoSLASHcountQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrackQueryKey = (options?: Options<SaveWelloTrackingUsingPost1Data>) => createQueryKey('saveWelloTrackingUsingPost1', options);

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrackOptions = (options?: Options<SaveWelloTrackingUsingPost1Data>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrack({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrackQueryKey(options)
    });
};

export const postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrackMutation = (options?: Partial<Options<SaveWelloTrackingUsingPost1Data>>) => {
    const mutationOptions: UseMutationOptions<SaveWelloTrackingUsingPost1Response, DefaultError, Options<SaveWelloTrackingUsingPost1Data>> = {
        mutationFn: async (localOptions) => {
            const { data } = await postMETHODSLASHwelloSLASHv2SLASHallowsSLASHwelloDASHtrack({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};